import { Navigate } from 'react-router-dom';
import { usePermissions } from '../../contexts/PermissionContext';
import { TokenService } from '../../lib/tokenService';
import {
  EMBEDDED_ENTRY_ROUTE,
  getStoredEmbeddedScreenState,
  getStoredShellMode
} from '../../lib/embeddedShell';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { userInfo } = usePermissions();
  const hasSession = TokenService.hasActiveSession();
  const shellMode = getStoredShellMode();
  const embeddedScreenState = getStoredEmbeddedScreenState();
  // Em embedded, segurar a rota sempre que houver userInfo OU sessão ativa,
  // independente do embeddedScreenState. Isso evita o bounce para /embedded
  // quando o launcher já autenticou (accessToken pode estar transitoriamente
  // vazio enquanto ssoToken/baseBearer seguram a sessão).
  const allowEmbeddedHold =
    shellMode === 'embedded' && (!!userInfo || hasSession);

  // Janela transiente após login/refresh: sessão já está válida, mas o
  // PermissionContext ainda está hidratando userInfo a partir do AuthContext.
  // hasSession === true significa que A SESSÃO É VÁLIDA — não derrubar.
  // Renderizar nada (Suspense-like) até userInfo chegar no próximo render.
  if (!userInfo && hasSession) {
    return null;
  }

  if ((!userInfo || !hasSession) && !allowEmbeddedHold) {
    const fallbackRoute = shellMode === 'embedded'
      ? EMBEDDED_ENTRY_ROUTE
      : '/login';

    console.warn('[ProtectedRoute] Acesso nao autorizado - redirecionando', {
      hasUserInfo: !!userInfo,
      hasSession,
      embeddedScreenState,
      fallbackRoute
    });

    return <Navigate to={fallbackRoute} replace />;
  }

  return <>{children}</>;
}
